import { isLooseGroup } from "@productlane/lib/src/help-center/loose-group"

import type { Positioned } from "./plan-insert"
import { planInsert } from "./plan-insert"

export type TopLevelPlacement =
	// Join the run of top-level pages that already sits at that spot.
	| { kind: "existing"; groupId: string; at: "start" | "end" }
	// Open a new run there; `siblings` are groups the new order pushes down.
	| { kind: "new"; order: number; siblings: Positioned[] }

// Where a page goes when it sits at the top of the tree, between `groups[index - 1]`
// and `groups[index]`. A neighbouring run of top-level pages takes it, so two runs
// never sit side by side; otherwise a new unnamed group opens at that spot.
export function planTopLevelPlacement(
	groups: readonly (Positioned & { name: string })[],
	index: number,
): TopLevelPlacement {
	const before = groups[index - 1]
	if (before && isLooseGroup(before)) {
		return { kind: "existing", groupId: before.id, at: "end" }
	}
	const after = groups[index]
	if (after && isLooseGroup(after)) {
		return { kind: "existing", groupId: after.id, at: "start" }
	}
	const { order, siblings } = planInsert(groups, index)
	return { kind: "new", order, siblings }
}
